(function () {
  'use strict';

  var surfaces = document.querySelectorAll('[data-yc-review-surface="page"]');
  if (!surfaces.length) return;

  function isSafeUrl(value, externalOnly) {
    if (typeof value !== 'string' || !value) return false;
    if (externalOnly) return /^https:\/\//i.test(value);
    return /^https:\/\//i.test(value) || value.charAt(0) === '/';
  }

  function addText(parent, tagName, className, value) {
    var node = document.createElement(tagName);
    if (className) node.className = className;
    node.textContent = value || '';
    parent.appendChild(node);
    return node;
  }

  function buildCard(review, verifiedLabel) {
    var card = document.createElement('article');
    card.className = 'yc-review-page-card';

    var media = document.createElement('div');
    media.className = 'yc-review-page-card__media';

    if (isSafeUrl(review.video_url, true)) {
      var iframe = document.createElement('iframe');
      iframe.src = review.video_url;
      iframe.title = review.product_title || 'Customer video review';
      iframe.loading = 'lazy';
      iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
      iframe.allowFullscreen = true;
      media.appendChild(iframe);
    } else if (isSafeUrl(review.image_url, false)) {
      var image = document.createElement('img');
      image.src = review.image_url;
      if (review.image_srcset) {
        image.srcset = review.image_srcset;
        image.sizes = '(min-width: 990px) 31vw, 92vw';
      }
      image.width = 1024;
      image.height = 1024;
      image.loading = 'lazy';
      image.decoding = 'async';
      image.alt = review.product_title || 'Customer photo review';
      media.appendChild(image);
    } else {
      addText(media, 'div', 'yc-review-card__media-empty', 'Customer story');
    }

    var body = document.createElement('div');
    body.className = 'yc-review-page-card__body';

    var rating = Math.max(0, Math.min(5, Number(review.rating) || 0));
    var stars = '';
    for (var index = 0; index < 5; index += 1) {
      stars += index < rating ? '★' : '☆';
    }
    var ratingNode = addText(body, 'div', 'yc-home-rating', stars);
    ratingNode.setAttribute('aria-label', rating + ' out of 5 stars');

    addText(body, 'h2', '', review.title || 'Customer review');
    addText(body, 'p', '', review.body || '');

    var meta = document.createElement('div');
    meta.className = 'yc-review-page-card__meta';
    meta.appendChild(document.createTextNode(review.reviewer_name || 'Verified customer'));
    if (review.verified) {
      var verified = document.createElement('span');
      verified.className = 'yc-review-verified';
      verified.textContent = ' · ' + (verifiedLabel || 'Verified purchase');
      meta.appendChild(verified);
    }
    body.appendChild(meta);

    if (review.product_title && isSafeUrl(review.product_url, false)) {
      var product = document.createElement('a');
      product.className = 'yc-review-page-card__product';
      product.href = review.product_url;
      product.textContent = review.product_title;
      body.appendChild(product);
    }

    card.appendChild(media);
    card.appendChild(body);
    return card;
  }

  function initialize(surface) {
    var fallbackUrl = surface.getAttribute('data-yc-review-fallback');
    var list = surface.querySelector('[data-yc-review-list]');
    var button = surface.querySelector('[data-yc-review-load-more]');
    var status = surface.querySelector('[data-yc-review-status]');
    var total = surface.querySelector('[data-yc-review-total]');
    var verifiedLabel = surface.getAttribute('data-yc-review-verified-label') || 'Verified purchase';
    var limit = Number(surface.getAttribute('data-yc-review-limit')) || 12;

    if (!fallbackUrl || !list) return;

    fetch(fallbackUrl, {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Review snapshot request failed');
        return response.json();
      })
      .then(function (payload) {
        var reviews = Array.isArray(payload.reviews) ? payload.reviews : [];
        if (!reviews.length) throw new Error('Review snapshot is empty');

        var visibleCount = 0;

        function render() {
          var articles = list.querySelectorAll('.yc-review-page-card');
          for (var index = 0; index < articles.length; index += 1) {
            articles[index].parentNode.removeChild(articles[index]);
          }

          var nextCount = Math.min(visibleCount + limit, reviews.length);
          var fragment = document.createDocumentFragment();
          for (var reviewIndex = 0; reviewIndex < nextCount; reviewIndex += 1) {
            fragment.appendChild(buildCard(reviews[reviewIndex], verifiedLabel));
          }

          if (status) {
            list.insertBefore(fragment, status);
          } else {
            list.appendChild(fragment);
          }
          visibleCount = nextCount;
          if (button) button.hidden = visibleCount >= reviews.length;
        }

        if (total && payload.source_review_count) {
          total.textContent = payload.source_review_count;
        }

        render();
        if (button) {
          button.addEventListener('click', render);
        }
      })
      .catch(function () {
        if (button) button.hidden = true;
        if (status) status.hidden = true;
      });
  }

  for (var surfaceIndex = 0; surfaceIndex < surfaces.length; surfaceIndex += 1) {
    initialize(surfaces[surfaceIndex]);
  }
}());
